module.exports = __webpack_public_path__ + "static/media/creativeMarket.777927d9.png";